import { useLocation, useNavigate, useParams } from "react-router-dom";
import React, { useState } from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  Chip,
  Grid,
  Typography,
} from "@mui/material";
import MainContainer from "../../layout/MainContainer";
import { DocumentViewer } from "../../components";
import Loader from "../../helpers/Loader";
import { useLazyGetFormsByIdQuery } from "../../services/forum";

const ForumDetails = () => {
  const navigate = useNavigate();
  const { _id } = useParams();
  const [img, setImg] = useState<string>("");
  const [open, setOpen] = useState<boolean>(false);
  const [forumData] = useLazyGetFormsByIdQuery();
  const [forumDetails, setForumDetails] = useState<any>(null);

  const fetchForumData = async () => {
    try {
      const response = await forumData({ id: _id }).unwrap();
      if (response.statusCode === 200) {
        setForumDetails(response.data);
      }
    } catch (error) {
      console.error(error);
    }
  };

  React.useEffect(() => {
    fetchForumData();
  }, [_id]);

  return (
    <MainContainer>
      <div className="main_loyout">
        <div className="dashboard">
          <h1 className="mn_hdng">View Forum Details</h1>
          <Button
            className="btn btn_primary"
            onClick={() => navigate("/manage-forum")}
          >
            Back
          </Button>
        </div>

        {forumDetails ? (
          <Card className="cards">
            <CardContent sx={{ p: 1 }}>
              <Grid container spacing={2} className="view_box">
                {forumDetails.images?.length > 0 && (
                  <Grid item xs={12}>
                    <Typography component="h5">Images</Typography>
                    <div
                      style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}
                    >
                      {forumDetails.images.map(
                        (image: string, index: number) => (
                          <figure
                            key={index}
                            className="profile_img"
                            onClick={() => {
                              setOpen(true);
                              setImg(image);
                            }}
                          >
                            <img
                              style={{
                                height: 100,
                                width: 150,
                                borderRadius: 4,
                                objectFit: "cover",
                              }}
                              src={image}
                              alt={`Forum image ${index + 1}`}
                            />
                          </figure>
                        )
                      )}
                    </div>
                  </Grid>
                )}

                <Grid item xs={12} className="view_box_list">
                  <Grid container spacing={3}>
                    <Grid item lg={4} md={4} sm={6} xs={12}>
                      <Box>
                        <Typography component="h5">Title</Typography>
                        <Typography component="p">
                          {forumDetails.title || "-"}
                        </Typography>
                      </Box>
                    </Grid>

                    <Grid item lg={4} md={4} sm={6} xs={12}>
                      <Box>
                        <Typography component="h5">Subjects</Typography>
                        {forumDetails.subjects?.length > 0 ? (
                          <Box
                            sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}
                          >
                            {forumDetails.subjects.map((subject: any) => (
                              <Chip
                                key={subject?._id}
                                label={subject?.name}
                                sx={{ marginRight: 1, marginBottom: 1 }}
                              />
                            ))}
                          </Box>
                        ) : (
                          <Typography component="p">-</Typography>
                        )}
                      </Box>
                    </Grid>

                    <Grid item lg={4} md={4} sm={6} xs={12}>
                      <Box>
                        <Typography component="h5">Status</Typography>
                        <Typography component="p">
                          {forumDetails.status ? "Active" : "Inactive"}
                        </Typography>
                      </Box>
                    </Grid>

                    <Grid item lg={4} md={4} sm={6} xs={12}>
                      <Box>
                        <Typography component="h5">Created By</Typography>
                        <Typography component="p">
                          {forumDetails.user?.name || "-"}
                        </Typography>
                      </Box>
                    </Grid>

                    <Grid item lg={4} md={4} sm={6} xs={12}>
                      <Box>
                        <Typography component="h5">Username</Typography>
                        <Typography component="p">
                          {forumDetails.user?.userName || "-"}
                        </Typography>
                      </Box>
                    </Grid>

                    <Grid item lg={4} md={4} sm={6} xs={12}>
                      <Box>
                        <Typography component="h5">Email</Typography>
                        <Typography component="p">
                          {forumDetails.user?.email || "-"}
                        </Typography>
                      </Box>
                    </Grid>

                    <Grid item lg={4} md={4} sm={6} xs={12}>
                      <Box>
                        <Typography component="h5">Phone Number</Typography>
                        <Typography component="p">
                          {forumDetails.user?.dialCode}{" "}
                          {forumDetails.user?.phoneNo || "-"}
                        </Typography>
                      </Box>
                    </Grid>

                    <Grid item lg={4} md={4} sm={6} xs={12}>
                      <Box>
                        <Typography component="h5">Created At</Typography>
                        <Typography component="p">
                          {new Date(forumDetails.createdAt).toLocaleString()}
                        </Typography>
                      </Box>
                    </Grid>

                    <Grid item lg={4} md={4} sm={6} xs={12}>
                      <Box>
                        <Typography component="h5">Views</Typography>
                        <Typography component="p">
                          {forumDetails.views || 0}
                        </Typography>
                      </Box>
                    </Grid>

                    <Grid item xs={12}>
                      <Box>
                        <Typography component="h5">Description</Typography>
                        <Typography
                          component="p"
                          style={{ whiteSpace: "pre-line" }}
                          dangerouslySetInnerHTML={{
                            __html: forumDetails.description || "",
                          }}
                        />
                        {/* {forumDetails.description || "-"} */}
                        {/* </Typography> */}
                      </Box>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        ) : (
          <Loader isLoad={true} />
        )}
      </div>
      <DocumentViewer open={open} setOpen={setOpen} img={img} />
    </MainContainer>
  );
};

export default ForumDetails;
